"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef } from "react";
import { LocationBadges } from "@/components/molecules/LocationMap/LocationBadges";
import { Input } from "@/components/ui/input";
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover";
import { Search, Loader2, ChevronsUpDown } from "lucide-react";
import { useTranslations } from "next-intl";
import { FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormLabel } from "@/components/atoms/Form/FormLabel";
import { useFormMultiLocationInput } from "./useFormMultiLocationInput";
import { useIsMobile } from "@/hooks/use-mobile";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { MultiLocationSearchContent } from "./MultiLocationSearchContent";
import LocationMapCaller from "@/components/molecules/LocationMap/LocationMapCaller";
import MapThumbnailCaller from "@/components/pages/search/map/components/MapThumbnailCaller";
import { SearchTypes } from "@/constants/filters";
type FormMultiLocationInputProps = {
  name: string;
  required?: boolean;
  maxLocations?: number;
};
export function FormMultiLocationInput(t0) {
  const $ = _c(91);
  const {
    name,
    required: t1,
    maxLocations
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    control,
    setValue,
    locationCodes,
    searchInput,
    queryInput,
    isSearching,
    locations,
    selectedLocations,
    locationPolygons,
    isMaxReached,
    handleSearchChange,
    handleToggleCode,
    handleRemoveCode,
    handleClearAll,
    handleMapSelectionChange
  } = useFormMultiLocationInput(name, maxLocations);
  let t2;
  if ($[0] !== selectedLocations) {
    t2 = new Map(selectedLocations.map(_temp));
    $[0] = selectedLocations;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedNames = t2;
  const t = useTranslations("modules.listings.addRoomListing.houseDetails");
  const isMobile = useIsMobile();
  const {
    openModal
  } = useModal();
  const [resultsOpen, setResultsOpen] = useState(false);
  const anchorRef = useRef(null);
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== handleSearchChange || $[3] !== handleToggleCode || $[4] !== isMaxReached || $[5] !== isSearching || $[6] !== locationCodes || $[7] !== locations || $[8] !== queryInput || $[9] !== resultsOpen || $[10] !== searchInput || $[11] !== t) {
    const visibleLocations = locations.filter(_temp2);
    t12 = "flex flex-col gap-2";
    T1 = Popover;
    t9 = resultsOpen && queryInput.length > 2;
    t10 = setResultsOpen;
    let t13;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-faint-foreground" />;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] !== handleSearchChange) {
      t14 = e => {
        handleSearchChange(e.target.value);
        setResultsOpen(true);
      };
      $[25] = handleSearchChange;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    let t16;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = () => setResultsOpen(true);
      t16 = () => setResultsOpen(true);
      $[27] = t15;
      $[28] = t16;
    } else {
      t15 = $[27];
      t16 = $[28];
    }
    let t17;
    if ($[29] !== t) {
      t17 = t("searchLocations");
      $[29] = t;
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    if ($[31] !== searchInput || $[32] !== t14 || $[33] !== t17) {
      t11 = <PopoverAnchor asChild={true}><div className="relative" ref={anchorRef}>{t13}<Input value={searchInput} onChange={t14} onFocus={t15} onClick={t16} placeholder={t17} className="pl-9" /></div></PopoverAnchor>;
      $[31] = searchInput;
      $[32] = t14;
      $[33] = t17;
      $[34] = t11;
    } else {
      t11 = $[34];
    }
    T0 = PopoverContent;
    t3 = "start";
    t4 = "w-[var(--radix-popover-trigger-width)] p-0";
    t5 = _temp3;
    t6 = _temp4;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = e_2 => {
        const target = e_2.detail.originalEvent.target as Node | null;
        if (target && anchorRef.current?.contains(target)) {
          e_2.preventDefault();
        }
      };
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    t8 = isSearching ? <div className="flex items-center justify-center py-4"><Loader2 className="h-5 w-5 animate-spin text-faint-foreground" /></div> : visibleLocations.length > 0 ? <div className="max-h-60 overflow-y-auto">{visibleLocations.map(loc_0 => {
        const isSelected = locationCodes.includes(loc_0.code);
        const isDisabled = isMaxReached && !isSelected;
        return <button key={loc_0.code} type="button" disabled={isDisabled} onClick={() => {
          handleToggleCode(loc_0.code, loc_0.proxyName ?? loc_0.name);
          setResultsOpen(false);
        }} className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between border-b last:border-b-0 ${isDisabled ? "opacity-40 cursor-not-allowed" : "hover:bg-muted cursor-pointer"} ${isSelected ? "bg-primary/5" : ""}`}><div><span className="font-medium">{loc_0.proxyName ?? loc_0.name}</span><span className="text-faint-foreground ml-2 text-xs">{loc_0.proxyAdministrativeLevel ?? loc_0.administrativeLevel}</span></div>{isSelected && <span className="text-primary text-xs font-medium">✓</span>}</button>;
      })}</div> : <p className="text-sm text-faint-foreground text-center py-4">{t("noLocationsFound")}</p>;
    $[2] = handleSearchChange;
    $[3] = handleToggleCode;
    $[4] = isMaxReached;
    $[5] = isSearching;
    $[6] = locationCodes;
    $[7] = locations;
    $[8] = queryInput;
    $[9] = resultsOpen;
    $[10] = searchInput;
    $[11] = t;
    $[12] = T0;
    $[13] = T1;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[12];
    T1 = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t13;
  if ($[36] !== T0 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
    t13 = <T0 align={t3} className={t4} onOpenAutoFocus={t5} onCloseAutoFocus={t6} onInteractOutside={t7}>{t8}</T0>;
    $[36] = T0;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== T1 || $[45] !== t10 || $[46] !== t11 || $[47] !== t13 || $[48] !== t9) {
    t14 = <T1 open={t9} onOpenChange={t10}>{t11}{t13}</T1>;
    $[44] = T1;
    $[45] = t10;
    $[46] = t11;
    $[47] = t13;
    $[48] = t9;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== handleMapSelectionChange || $[51] !== locationCodes || $[52] !== selectedNames) {
    t15 = <div className="h-80 overflow-hidden rounded-2xl border border-input"><LocationMapCaller businessType={SearchTypes.RENT_ROOM} selectedCodes={locationCodes} onSelectionChange={handleMapSelectionChange} selectedNames={selectedNames} showBadges={false} showCount={false} /></div>;
    $[50] = handleMapSelectionChange;
    $[51] = locationCodes;
    $[52] = selectedNames;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t12 || $[55] !== t14 || $[56] !== t15) {
    t16 = <div className={t12}>{t14}{t15}</div>;
    $[54] = t12;
    $[55] = t14;
    $[56] = t15;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  const searchContent = t16;
  let t17;
  if ($[58] !== control || $[59] !== maxLocations || $[60] !== name || $[61] !== openModal || $[62] !== setValue) {
    t17 = (mode, title) => {
      openModal(ModalTypeEnum.GENERIC_SHEET, {
        side: "bottom",
        hasClose: true,
        className: "h-dvh flex flex-col",
        childrenClassName: "flex flex-col flex-1 min-h-0 overflow-hidden p-0",
        title,
        children: <MultiLocationSearchContent name={name} maxLocations={maxLocations} control={control} setValue={setValue} showSearch={mode === "search"} showMapPicker={mode === "map"} />
      });
    };
    $[58] = control;
    $[59] = maxLocations;
    $[60] = name;
    $[61] = openModal;
    $[62] = setValue;
    $[63] = t17;
  } else {
    t17 = $[63];
  }
  const openPickerSheet = t17;
  let t18;
  if ($[64] !== openPickerSheet || $[65] !== t) {
    t18 = () => openPickerSheet("search", t("searchLocations"));
    $[64] = openPickerSheet;
    $[65] = t;
    $[66] = t18;
  } else {
    t18 = $[66];
  }
  const handleOpenSearchSheet = t18;
  let t19;
  if ($[67] !== openPickerSheet || $[68] !== t) {
    t19 = () => openPickerSheet("map", t("placesOfInterest"));
    $[67] = openPickerSheet;
    $[68] = t;
    $[69] = t19;
  } else {
    t19 = $[69];
  }
  const handleOpenMapSheet = t19;
  let t20;
  if ($[70] !== selectedLocations || $[71] !== t) {
    t20 = selectedLocations.length > 0 ? selectedLocations.map(_temp5).join(", ") : t("searchLocations");
    $[70] = selectedLocations;
    $[71] = t;
    $[72] = t20;
  } else {
    t20 = $[72];
  }
  const displayText = t20;
  let t21;
  if ($[73] !== displayText || $[74] !== handleClearAll || $[75] !== handleOpenMapSheet || $[76] !== handleOpenSearchSheet || $[77] !== handleRemoveCode || $[78] !== isMaxReached || $[79] !== isMobile || $[80] !== locationPolygons || $[81] !== maxLocations || $[82] !== required || $[83] !== searchContent || $[84] !== selectedLocations || $[85] !== t) {
    t21 = () => <FormItem><div className="flex flex-col gap-3"><div><FormLabel required={required} className="text-base sm:text-base">{t("placesOfInterest")}</FormLabel><p className="text-sm text-faint-foreground mt-1">{t("placesOfInterestDescription")}</p></div><LocationBadges locations={selectedLocations} onRemove={handleRemoveCode} onClearAll={handleClearAll} single={maxLocations === 1} />{isMaxReached && <p className="text-xs text-faint-foreground">{t("maxLocationsReached", {
            max: maxLocations ?? 0
          })}</p>}{isMobile ? <div className="flex flex-col gap-3"><button type="button" role="combobox" onClick={handleOpenSearchSheet} className="flex h-11 w-full max-w-full min-w-0 items-center justify-between gap-2 rounded-full border border-input bg-card px-4 text-sm md:text-base text-muted-foreground shadow-xs transition-[color,box-shadow] cursor-pointer focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-ring/20 focus-visible:ring-[3px]"><span className="flex-1 min-w-0 truncate text-left">{displayText}</span><ChevronsUpDown className="size-4 shrink-0 opacity-50" /></button><div onClick={handleOpenMapSheet} className="cursor-pointer"><MapThumbnailCaller polygonPrimary={locationPolygons} className="h-56 w-full rounded-3xl border border-input overflow-hidden" emptyBgClassName="bg-card" emptyMessage={t("selectOnMap")} /></div></div> : searchContent}</div><FormMessage /></FormItem>;
    $[73] = displayText;
    $[74] = handleClearAll;
    $[75] = handleOpenMapSheet;
    $[76] = handleOpenSearchSheet;
    $[77] = handleRemoveCode;
    $[78] = isMaxReached;
    $[79] = isMobile;
    $[80] = locationPolygons;
    $[81] = maxLocations;
    $[82] = required;
    $[83] = searchContent;
    $[84] = selectedLocations;
    $[85] = t;
    $[86] = t21;
  } else {
    t21 = $[86];
  }
  let t22;
  if ($[87] !== control || $[88] !== name || $[89] !== t21) {
    t22 = <FormField control={control} name={name} render={t21} data-sentry-element="FormField" data-sentry-component="FormMultiLocationInput" data-sentry-source-file="FormMultiLocationInput.tsx" />;
    $[87] = control;
    $[88] = name;
    $[89] = t21;
    $[90] = t22;
  } else {
    t22 = $[90];
  }
  return t22;
}
function _temp5(l_0) {
  return l_0.name;
}
function _temp4(e_1) {
  return e_1.preventDefault();
}
function _temp3(e_0) {
  return e_0.preventDefault();
}
function _temp2(loc) {
  return loc.code !== null;
}
function _temp(l) {
  return [l.code, l.name];
}